// Alto de la AppBar del layout vertical. Solo se muestra bajo 1200px de ancho (ver VerticalDefault), y como es fija,
// las páginas que pegan algo al borde superior necesitan este alto para no quedar debajo de ella.
export const HEADER_HEIGHT = 68;
